import { useId } from "react";

import { classNames, ToggleOptions } from "@alpacahq/ui/old";

interface YesNoToggleProps {
  label: string;
  value: boolean | null;
  onChange: (value: boolean) => void;
  errorMsg?: string;
  className?: string;
}

const OPTIONS: { label: string; value: boolean }[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const YesNoToggle = ({
  label,
  value,
  onChange,
  errorMsg,
  className,
}: YesNoToggleProps) => {
  const errorId = useId();

  return (
    <div className={classNames("flex flex-col items-start gap-2", className)}>
      <span className="block font-semibold text-gray-800 text-sm">{label}</span>
      <div aria-describedby={errorMsg ? errorId : undefined}>
        <ToggleOptions<boolean>
          ariaLabel={label}
          options={OPTIONS}
          value={value}
          onChange={onChange}
        />
      </div>
      {errorMsg && (
        <p id={errorId} className="m-0 p-0 text-red-500 text-xs">
          {errorMsg}
        </p>
      )}
    </div>
  );
};
